import React from 'react';
import messages from '../../../locale/messages';
import AdditionalFeesContainer from './AdditionalFeesContainer';
import DashboardLayout from '../../../components/Shop/StoreLayout/Layout/DashboardLayout';

function action({ store, params, intl }) {
    const title = intl.formatMessage(messages.additionalFee);

    let isStoreAuthenticated = store.getState().runtime.isStoreAuthenticated;

    if (!isStoreAuthenticated) {
        return { redirect: '/store/login' };
    };

    return {
        title,
        component: (
            <DashboardLayout>
                <AdditionalFeesContainer title={title} />
            </DashboardLayout>
        )
    }
}

export default action;
